"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationStatusStyles = exports.notificationSizeStyles = exports.notificationBaseStyle = exports.NOTIFICATION_STATUSES = void 0;
const NOTIFICATION_STATUSES = exports.NOTIFICATION_STATUSES = {
  NEUTRAL: 'neutral',
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success'
};
const NOTIFICATION_SIZES = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg'
};
const notificationBaseStyle = exports.notificationBaseStyle = {
  container: {
    paddingY: 2,
    borderRadius: 'base'
  },
  actionButton: {
    fontSize: 'sm',
    height: 'fit-content',
    lineHeight: '1.4',
    color: 'primary.600',
    _hover: {
      color: 'primary.700'
    }
  },
  dismissButton: {
    color: 'gray.600',
    borderColor: 'transparent',
    borderWidth: '2px',
    padding: 0,
    width: 10,
    height: 10,
    backgroundColor: 'transparent',
    borderRadius: 'base',
    marginLeft: 2,
    _hover: {
      color: 'gray.700'
    },
    _focus: {
      color: 'gray.700',
      borderColor: 'white',
      boxShadow: 'outline'
    }
  },
  icon: {
    width: 6,
    marginRight: 2,
    height: 'auto'
  },
  description: {
    lineHeight: 1.4
  },
  title: {
    lineHeight: 1.4
  },
  variants: {},
  sizes: {
    sm: {
      title: {
        fontSize: 'xs'
      },
      description: {
        fontSize: 'xs'
      }
    },
    md: {
      title: {
        fontSize: 'sm'
      },
      description: {
        fontSize: 'sm'
      }
    },
    lg: {
      title: {
        fontSize: 'base'
      },
      description: {
        fontSize: 'base'
      }
    }
  }
};
const notificationStatusStyles = status => {
  switch (status) {
    case NOTIFICATION_STATUSES.NEUTRAL:
      return {
        container: {
          background: 'gray.light'
        },
        icon: {
          color: 'gray.dark'
        },
        dismissButton: {
          _hover: {
            background: 'gray.200'
          },
          _focus: {
            background: 'gray.200'
          }
        }
      };
    case NOTIFICATION_STATUSES.WARNING:
      return {
        container: {
          background: 'yellow.100'
        },
        icon: {
          color: 'yellow.500'
        },
        dismissButton: {
          _hover: {
            background: 'yellow.200'
          },
          _focus: {
            background: 'yellow.200'
          }
        }
      };
    case NOTIFICATION_STATUSES.ERROR:
      return {
        container: {
          background: 'red.100'
        },
        icon: {
          color: 'red.700'
        },
        dismissButton: {
          _hover: {
            background: 'red.200'
          },
          _focus: {
            background: 'red.200'
          }
        }
      };
    case NOTIFICATION_STATUSES.SUCCESS:
      return {
        container: {
          background: 'green.100'
        },
        icon: {
          color: 'green.700'
        },
        dismissButton: {
          _hover: {
            background: 'green.200'
          },
          _focus: {
            background: 'green.200'
          }
        }
      };
    default:
      return {};
  }
};
exports.notificationStatusStyles = notificationStatusStyles;
const notificationSizeStyles = size => {
  switch (size) {
    case NOTIFICATION_SIZES.SM:
      return {
        title: {
          fontSize: 'xs'
        },
        description: {
          fontSize: 'xs'
        }
      };
    case NOTIFICATION_SIZES.MD:
      return {
        title: {
          fontSize: 'sm'
        },
        description: {
          fontSize: 'sm'
        }
      };
    case NOTIFICATION_SIZES.LG:
      return {
        title: {
          fontSize: 'base'
        },
        description: {
          fontSize: 'base'
        }
      };
    default:
      return {};
  }
};
exports.notificationSizeStyles = notificationSizeStyles;